import { render, staticRenderFns } from "./bahtIcon.vue?vue&type=template&id=7ff1d756&scoped=true"
import script from "./bahtIcon.vue?vue&type=script&lang=js"
export * from "./bahtIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1d756",
  null
  
)

export default component.exports